// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__2l5Ts","title":"style__title__gVDtB","description":"style__description__xunMV","component":"style__component__9+gm9"};